import { render, staticRenderFns } from "./inActive.vue?vue&type=template&id=279c0647"
import script from "./inActive.vue?vue&type=script&lang=js"
export * from "./inActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports